﻿﻿import { YesNoUnknown } from '../enums/index';
import { AgreementLevel } from '../enums/index';

export interface IDashProgressTracking {
    hasBeenContacted: boolean;
    canChangeCenter: boolean;
    timesCheckedIfContacted: number;
    contactedDateTime: Date;
    noContactReportDateTime: Date;
    noContactReportDetails: string;
    workupScheduledDateTime: Date;
    workupCompletedDateTime: Date;
    preOpScheduledDateTime: Date;
    preOpCompletedDateTime: Date;
    surgeryScheduledDateTime: Date;
    surgeryCompletedDateTime: Date;
    isSurgeryConfirmed: boolean;
    surveyWorkupTreatment: number;
    surveyWorkupConvenience: number;
    surveyWorkupFacility: number;
    surveyWorkupComments: string;
    surveyWorkupCommendations: string;
    surveyPreOpTreatment: number;
    surveyPreOpConvenience: number;
    surveyPreOpFacility: number;
    surveyPreOpComments: string;
    surveyPreOpCommendations: string;
    surveyAtSurgeryTreatment: number;
    surveyAtSurgeryFacility: number;
    surveyAtSurgeryConvenience: number;
    surveyAtSurgeryComments: string;
    surveyAtSurgeryCommendations: string;
    surveySurgeonCare: number;
    surveyNurseCare: number;
    surveyPainCare: number;
    surveyCaretakerTreatment: number;
    surveyNeededReimbursement: YesNoUnknown;
    surveyAdditionalComments: string;
    surveySurgeryCommendations: string;
    surveyDonationWasFinancialBurden: AgreementLevel;
    surveyDonationCostWasImportant: AgreementLevel;
}
